
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiUndoIec as ObiUndoIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-undo-iec.js';
 
 
 

 
 export const ObiUndoIec = createComponent({
   react: React,
   tagName: 'obi-undo-iec',
   elementClass: ObiUndoIecElement,
   events: {
     
   }
  });
 
 